/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit MaskedInput.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import React from 'react'
import { css } from "emotion"

let styles = {}
styles.MaskedInput1 = css({label: 'MaskedInput1',
  alignSelf: "stretch",
color: "#161616",
fontFamily: "WonderUnitSans",
letterSpacing: 0.1,
borderStyle: "solid",
borderWidth: 2,
"&:focus:enabled": {
backgroundColor: "white",
borderColor: "#00a2ff"
},
"&:disabled": {
backgroundColor: "transparent",
borderColor: "#ffffff",
paddingTop: 0
},
"&::placeholder": {
color: "#808080",
textTransform: "none"
},
  
transition: 'background-color 150ms linear, border-color 150ms linear',
willChange: 'background-color, border-color',
  backgroundColor: 'var(--backgroundColor)',
borderBottomLeftRadius: 'var(--borderBottomLeftRadius)',
borderBottomRightRadius: 'var(--borderBottomRightRadius)',
borderTopLeftRadius: 'var(--borderTopLeftRadius)',
borderTopRightRadius: 'var(--borderTopRightRadius)',
fontSize: 'var(--fontSize)',
fontWeight: 'var(--fontWeight)',
marginLeft: 'var(--marginLeft)',
marginBottom: 'var(--marginBottom)',
marginTop: 'var(--marginTop)',
marginRight: 'var(--marginRight)',
paddingBottom: 'var(--paddingBottom)',
paddingLeft: 'var(--paddingLeft)',
paddingRight: 'var(--paddingRight)',
paddingTop: 'var(--paddingTop)',
borderColor: 'var(--borderColor)',
width: 'var(--width)',
textTransform: 'var(--textTransform)'})

export default function MaskedInput({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  backgroundColor= "#f2f2f2",
borderBottomLeftRadius= 8,
borderBottomRightRadius= 8,
borderTopLeftRadius= 8,
borderTopRightRadius= 8,
autoComplete= "on",
autoFocus,
className,
disabled,
fontSize= 16,
fontWeight= 300,
marginLeft= 0,
marginBottom= 0,
marginTop= 0,
marginRight= 0,
onBlur,
onChange,
onFocus,
onKeyUp,
onCopy,
onPaste,
onSubmit,
paddingBottom= 16,
paddingLeft= 16,
paddingRight= 16,
paddingTop= 16,
placeholder,
width= 200,
innerRef,
textTransform= "capitalize",
isInvalid,
isDisabled
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<input
 type="text"
 data-testid="MaskedInput.MaskedInput:1"
 data-view-path={dataViewPath}
 autoComplete={autoComplete}
 autoFocus={autoFocus}
 disabled={disabled}
 onBlur={onBlur}
 onChange={onChange}
 onFocus={onFocus}
 onKeyUp={onKeyUp}
 onCopy={onCopy}
 onPaste={onPaste}
 onSubmit={onSubmit}
 placeholder={placeholder}
 ref={innerRef}
 style={{'--backgroundColor': backgroundColor,'--borderBottomLeftRadius': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--borderBottomRightRadius': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--borderTopLeftRadius': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--borderTopRightRadius': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--fontSize': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--fontWeight': fontWeight,'--marginLeft': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--marginBottom': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--marginTop': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--marginRight': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--paddingBottom': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--paddingLeft': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--paddingRight': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--paddingTop': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--width': typeof width === 'number' ? `${width}px` : width,'--textTransform': textTransform,'--borderColor': isInvalid ? "rgba(224,51,51, 0.75)" : "transparent"}}
 className={`views-capture ${className} ${styles.MaskedInput1}`}
/>
{children}
</React.Fragment>)
}